<template>
  <v-container fill-height fluid>
    <v-card v-bind:style="styleObject">
      <div class="card-header">
        <h2 class="font-weight-regular">Semanggi Apps</h2>
      </div>
      <v-container style="margin-bottom: 1rem">
        <v-form
          @submit="validate"
          ref="form"
          v-model="valid"
          lazy-validation
          v-bind:style="{ width: '325px' }"
        >
          <v-text-field
            v-model="email"
            label="E-mail / Username / Phone"
            required
            v-on:keyup.enter="validate"
          ></v-text-field>
          <v-text-field
            v-model="password"
            label="Password"
            type="password"
            required
            v-on:keyup.enter="validate"
          ></v-text-field>
          <v-btn
            :disabled="!valid"
            block
            x-large
            class="btn-login mr-4 mt-4"
            @click="validate"
            >Login</v-btn
          >
          <p class="my-3 text-center">atau login dengan</p>
          <button
            type="button"
            class="btn-login-google mr-4 v-btn"
            @click="loginByGoogle"
          >
            <div class="google-icon-wrapper">
              <img
                class="google-icon"
                src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
              />
            </div>
            <span>Google</span>
          </button>
        </v-form>
      </v-container>
    </v-card>
  </v-container>
</template>
<style scoped>
.card-header {
  background-color: #27ae60 !important;
  text-align: center;
  padding: 1rem;
}
.card-header h2 {
  margin: 0;
  color: #fff;
}
.btn-login {
  background-color: #27ae60 !important;
  color: #fff;
  padding: 0;
  text-transform: capitalize !important;
  font-size: 1.3rem;
}
.btn-login-google {
  background-color: #4285f4;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  flex-direction: row;
  min-width: 100% !important;
  height: 52px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
.btn-login-google span {
  flex: 1;
}
.google-icon-wrapper {
  background-color: #fff;
  width: 20%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  margin: 2px;
  display: flex;
  border-radius: 3px;
}
.google-icon {
  width: 18px;
  height: 18px;
}
</style>
<script>
import { mapActions } from "vuex";
import firebase from "firebase/app";

export default {
  data() {
    return {
      valid: true,
      styleObject: {
        margin: "1rem auto",
        borderRadius: "8px",
      },
      password: "",
      // nameRules: [
      //   v => !!v || "Username is required",
      //   v =>
      //     (v && v.length <= 10) || "Username must be greater than 10 character"
      // ],
      email: "",
      // emailRules: [
      //   v => !!v || "E-mail is required",
      //   v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      // ]
    };
  },
  created() {
    this.verify();
  },
  methods: {
    ...mapActions({
      logIn: "auth/logIn",
      logInByGoogle: "auth/logInByGoogle",
      getUsers: "auth/getUsers",
      verymail: "user/verymail",
    }),
    async verify() {
      if (this.$route.query.token) {
        let payload = {
          token: this.$route.query.token,
        };
        const response = await this.verymail(payload);
        if (response.data.success) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Akun Berhasil di verifikasi!",
          });
        }
      }
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        const fcm_token = localStorage.getItem("fcm_token");
        const payload = {
          email: this.email,
          password: this.password,
          fcm_token: fcm_token ? fcm_token : "",
        };
        try {
          const response = await this.logIn(payload);
          if (!response.data.success) {
            this.$notify({
              group: "custom-notification",
              type: "error",
              title: "Oops!",
              text: response.data.message,
            });
          } else {
            this.$router.push("/dashboard");
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: "Successfully login!",
            });
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    async loginByGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      try {
        const auth = await this.$firebaseApp.auth().signInWithPopup(provider);
        const user = auth.user;
        const idToken = await user.getIdToken();
        const payload = {
          firebase_token: idToken,
        };
        await this.logInByGoogle(payload);
        this.$router.push("/dashboard");
        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "Successfully login!",
        });
      } catch (error) {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        const credential = error.credential;
        console.log(error);
        if (errorCode) {
          this.$notify({
            group: "custom-notification",
            type: "error",
            title: "Oops!",
            text: "Login gagal!",
          });
        }
      }
    },
  },
};
</script>
